import * as React from 'react'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import { InventorySearchFilter, API } from '@getgreenline/homi-shared'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { parseAndDownloadCSV } from '../../../../utilities/helpers'
import { BlazeButton } from '../../../../components/CustomButtons/BlazeButton'
import { Track } from '../../../../Track'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  selectedLocationIds: number[]
  selectedCategoryIds: string[]
  showCategory: boolean
  showBrand: boolean
  searchFilters: InventorySearchFilter
  widthBreakPoint?: number
}

interface State {
  isLoading: boolean
}

@inject('currentCompanyStore')
@observer
export class ExportInventoryButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isLoading: false,
    }
  }

  export() {
    console.log('Exporting...')
    // LocationIds are locations the user has view inventory permissions on
    const { selectedLocationIds } = this.props
    const { locations, company } = this.props.currentCompanyStore!

    this.setState({ isLoading: true })

    // override offset and limit to return everything
    const searchFiltersWithAVeryBigLimit: InventorySearchFilter = {
      ...this.props.searchFilters,
      locationIds: selectedLocationIds,
      offset: 0,
      limit: 999999,
    }

    API.getInventoryByMultipleLocations(company!.id, searchFiltersWithAVeryBigLimit)
      .then((result) => {
        Track.track('dashboard:inventory_exported')
        this.setState({ isLoading: false })
        const multiLocationInventories = result.multiLocationInventory
        const inventoryJSON = multiLocationInventories.map((multiLocationInventory) => {
          const product = multiLocationInventory.product
          const object = {
            ID: product.id,
            SKU: product.sku,
            'Product Name': product.parentProductName
              ? `${product.parentProductName} - ${product.name}`
              : product.name,
            // Parent category ID is always filled in even if the category is standalone. Check for equality to find true parent/child relationship.
            Category:
              product.parentCategoryId && product.categoryId !== product.parentCategoryId
                ? `${product.parentCategoryName} - ${product.categoryName}`
                : product.categoryName,
            Brand: product.supplierName,
            'Image URL': product.imageUrl,
            'Retail price': product.price ? `$${(product.price / 100).toFixed(2)}` : '',
            'Deposit Fee': product.depositFee ? `$${(product.depositFee / 100).toFixed(2)}` : '',
            'Wholesale cost': product.purchasePrice
              ? `$${(product.purchasePrice / 100).toFixed(2)}`
              : '',
            Description: product.description,
            Barcode: product.barcode,
            'Net product weight': product.weight,
            'Cannabis Weight': product.cannabisWeight,
            'Cannabis Volume': product.cannabisVolume,
            Created: moment(product.createDate).format('YYYY-MM-DD hh:mm'),
            Updated: moment(product.updateDate).format('YYYY-MM-DD hh:mm'),
          }
          multiLocationInventory.inventories.map((inventory) => {
            const matchingLocation = (locations || []).find(
              (location) => location.id === inventory.locationId,
            )
            object[matchingLocation ? matchingLocation.name : '-'] = inventory.quantity
          })
          return object
        })

        parseAndDownloadCSV(`inventory-export-${moment().format('YYYY-MM-DD')}`, inventoryJSON)
      })
      .catch((error) => {
        console.error(error)
        this.setState({ isLoading: false })
      })
  }

  render() {
    return (
      <BlazeButton
        buttonProps={{
          icon: 'download',
          disabled: this.state.isLoading,
          loading: this.state.isLoading,
          onClick: () => this.export(),
        }}
        titleProps={{
          title: 'Export',
          widthBreakPoint: this.props.widthBreakPoint,
        }}
      />
    )
  }
}
